import React from 'react';
import { YOTPO } from 'shop/lib/util/const';
import hive from '@bombas/hive';
import * as Styled from './ProductRatingV2.styled';
/**
 * Wrapper for yotpo Star Rating for a product
 */
var ProductRatingV2 = function (_a) {
    var id = _a.id;
    var handleClick = function (event) {
        event.preventDefault();
        hive.track('REVIEW_WIDGET_CLICK', undefined);
        var yotpoClickable = document.querySelector('.yotpo-sr-bottom-line-summary');
        if (yotpoClickable) {
            yotpoClickable.click();
        }
    };
    return (React.createElement(Styled.ProductRatingV2, { onClick: handleClick },
        React.createElement("div", { className: "yotpo-widget-instance", "data-yotpo-instance-id": YOTPO.star_widget, "data-yotpo-product-id": id })));
};
export default ProductRatingV2;
